import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BusinessSearchResult } from '../../interfaces/business-search-results/business-search-result';
import { Router } from '@angular/router';
import { eOrderStatusType } from '../../enums';
import { BusinessReportForBusinessSearchResult } from '../../interfaces/business-reports-for-business-search-result/business-search-result';
import { Subject, takeUntil } from 'rxjs';
import { Order } from '../../interfaces/orders/order';
import { OrderManagerService } from '../../services/order-manager/order-manager.service';

@Component({
    selector: 'lib-business-search-result-preview',
    templateUrl: './business-search-result-preview.component.html',
    styleUrls: ['./business-search-result-preview.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinessSearchResultPreviewComponent {
  @Input() result!: BusinessSearchResult

  constructor(private router: Router) { }
    
  onReportSelected(orderId: string): void {
    if (orderId) {
      this.router.navigate(['/orders', orderId], {
        queryParams: { businessSearchResultID: this.result.id }
      });
    }
  }

  getReports(): BusinessReportForBusinessSearchResult[] {
    return this.result.businessReports?.filter(report => report.businessReportOrderOrderStatusTypeID !== eOrderStatusType.cancelled) ?? [];
  }
}
